<nav class="bg-gray-800 flex flex-row justify-between items-center">
  <div class="flex flex-row ml-10 mr-4 p-2 items-center">
    <div class="h-10 w-10 rounded-full mr-4 bg-gray-50 bg-opacity-0">
      <img src="assets/images/musix-logo.svg" alt="">
    </div>
    <a class="font-bold text-xl text-gray-50 hover:text-green-200" [routerLink]="['/dashboard']" routerLinkActive="router-link-active" >Spotlight</a>
  </div>
  <input class="rounded text-lg bg-gray-600 w-1/3 pt-2 pb-2 pl-6 pr-6 ml-2 mr-2 border-none outline-none" type="search" placeholder="Search for music"
    (keyup.enter)="searchArtist(inputSearchArtist.value)" #inputSearchArtist>
    <div class="ml-2 rounded-full mr-10 bg-gray-50 cursor-pointer" (click)="show = !show">
      <img [src]="photo" class="rounded-full h-10 w-10">
    </div>

  <div *ngIf="show" class="border-gray-400 p-6 m-4 fixed right-0 bg-gray-100 rounded-lg shadow-lg flex flex-col">
    <p class="text-sm font-medium md-1">{{name}}</p>
    <button class="text-sm font-medium mt-1 hover:text-green-200" (click)="auth.logout({ returnTo: 'https://www.google.com' })">Log out</button>
  </div>
</nav>
<div *ngIf="artists.length>0">
  <div class="bg-gray-100 p-4 mt-4 mb-4">
    <div class="flex flex-col">
      <h1 class="font-extrabold text-2xl p-6"></h1>
      <div class="flex flex-wrap justify-center items-center">
        <ul *ngFor="let item of artists">
          <app-artist-card [artist]="item" (click)="clickEvent(item)"></app-artist-card>
        </ul>
      </div>
    </div>
  </div>
</div>
